module.exports = __webpack_public_path__ + "img/icone-duvida.48704c91.svg";